import React from 'react';
import { useSelector } from 'react-redux';
import './index.scss';

import AssociatePopupControlCenter from '../AssociatePopupControlCenter';

const AssociatePopupControlCenters = ({ controlCenters, title, checked, handleChecked, hideCourierName, emptyTitleText }) => {
    const isLoading = useSelector(state => state.sectionsWrapperData.isLoading);


    return (
        <div className="courierGroupContainer">
            <div className="headerGroup">
                <span>{title ? title : ''}</span>
                {isLoading && <div className={'loader'} />}
            </div>
            {(controlCenters || [])
                .filter(controlCenter => controlCenter.info && controlCenter.info.userId)
                .map(controlCenter => (
                    <AssociatePopupControlCenter
                        key={controlCenter.controlCenterId}
                        controlCenter={controlCenter}
                        checked={checked}
                        onChecked={handleChecked}
                        hideCourierName={hideCourierName}
                    />
                ))}

            {(!controlCenters || !controlCenters.length) &&
                emptyTitleText && (
                    <div className="containerEmpty">
                        <span className="empty">{emptyTitleText}</span>
                    </div>
                )}
        </div>
    );
};

export default AssociatePopupControlCenters;
